import Actid from './Pages/routes';

export default [
  Actid,
];
